import React, { useCallback } from 'react';
import { ArticleCard } from '@americanexpress/consumer-travel-base';
import { ArticleData } from '../../../types/PersonalizedMarketingArticles.ts';
import { MODULE_NAME } from '../../../constants/moduleConstants.ts';

type ArticleProps = {
  article: ArticleData,
  element: string,
  hasFilters: boolean,
  isHorizontal: boolean
  track: any,
};

export const DefaultArticle = ({
  article, element, hasFilters, isHorizontal, track,
}: ArticleProps) => {
  const triggerOnClickAnalytics = useCallback(() => {
    track({
      event: {
        type: 'click',
        element,
        identifier: MODULE_NAME,
      },
    });
  }, [element, track]);

  return (
    <ArticleCard
      title={article.title}
      body={article.body}
      disclaimer={article.disclaimer}
      imageUrl={article.imageUrl}
      fallbackImageUrl={article.fallbackImageUrl}
      badge={article.attribution}
      triggerOnClickAnalytics={triggerOnClickAnalytics}
      analytics={{
        analyticsElement: element,
        isTrackImpressions: true,
      }}
      cta={{
        label: article?.ctaLabel,
        link: article?.ctaDestination,
        showCtaButton: !hasFilters,
      }}
      orientation={isHorizontal ? 'horizontal' : 'vertical'}
    />
  );
};
